import type { AxiosPromise } from 'axios';
import BaseClient from './BaseClient';
import type { FranchiseHubLayoutDocument, FranchiseHubLayoutResponse } from './franchiseHub/franchiseHubClient.types';

class AdminFranchiseHubClient extends BaseClient {
    updateLayout(teamId: number, layout: FranchiseHubLayoutDocument): AxiosPromise<FranchiseHubLayoutResponse> {
        const url = `/api/admin/teams/${teamId}/franchise-hub/layout`;
        return this.makeCoreApiRequest(url, 'put', layout);
    }

    deleteLayout(teamId: number): AxiosPromise<void> {
        const url = `/api/admin/teams/${teamId}/franchise-hub/layout`;
        return this.makeCoreApiRequest(url, 'delete');
    }
}

export default new AdminFranchiseHubClient();
